"use client";

import { useEffect } from "react";

export function ServiceWorker() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js")
        .then(() => console.log("Service worker registered"))
        .catch((err) => console.warn("SW registration failed:", err));
    }
  }, []);

  return null;
}
